import { render } from "./PrevLeaderBoardSection.vue?vue&type=template&id=448b14a8&scoped=true"
import script from "./PrevLeaderBoardSection.vue?vue&type=script&lang=js"
export * from "./PrevLeaderBoardSection.vue?vue&type=script&lang=js"

import "./PrevLeaderBoardSection.vue?vue&type=style&index=0&id=448b14a8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448b14a8"]])

export default __exports__